import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { HEADER_LOGO, HEADER_LOGO_BLUE } from "@/lib/faro";
import { LANDING_NAV } from "@/data/permitLandings";

const PUNTOS_NAV = [
  { label: "Recuperar hasta 4 puntos en 1 día (curso parcial · Tipo A)", to: "/recuperacion-de-puntos-vigo" },
  { label: "Recuperar el carnet o sentencia judicial (curso total 20 h · B1, B2 y B3)", to: "/curso-sensibilizacion-vigo" },
  { label: "Ciclo adicional (4 h · para volver a examen)", to: "/ciclo-adicional-vigo" },
  { label: "Próximos cursos y fechas", to: "/proximos-cursos" },
];

const CENTROS_NAV = [
  { label: "Vigo · Plaza América", to: "/autoescuela-plaza-america" },
  { label: "Vigo · Coruxo", to: "/autoescuela-coruxo" },
  { label: "Panxón", to: "/autoescuela-panxon" },
  { label: "Nigrán", to: "/autoescuela-nigran" },
  { label: "A Cañiza", to: "/autoescuela-a-caniza" },
];

const CARNETS_NAV = [
  ...LANDING_NAV,
  { label: "Intensivo de teórica (1 semana)", to: "/curso-intensivo-teorica-vigo" },
  { label: "Criterios de examen DGT", to: "/criterios-dgt" },
];

const NAV = [
  { label: "Carnets", href: "/permisos", dropdown: CARNETS_NAV, catalog: "Catálogo completo de permisos" },
  { label: "Permiso por Puntos", href: "/permiso-por-puntos-vigo", dropdown: PUNTOS_NAV, catalog: "¿Qué curso de puntos necesito? · Calculadora" },
  { label: "CAP", href: "/curso-cap-vigo" },
  { label: "Test DGT", href: "/examen" },
  { label: "Centros", href: "/centros", dropdown: CENTROS_NAV, catalog: "Ver todos los centros" },
  { label: "Blog", href: "/blog" },
];

const DesktopNavItem = ({ item }) => {
  if (!item.dropdown) {
    return (
      <a
        href={item.href}
        data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
        className="relative text-base font-bold text-white hover:text-[var(--faro-yellow)] transition-colors after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:bg-[var(--faro-yellow)] after:transition-all hover:after:w-full whitespace-nowrap"
      >
        {item.label}
      </a>
    );
  }
  return (
    <div className="relative group">
      <a
        href={item.href}
        aria-haspopup="true"
        data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
        className="relative inline-flex items-center gap-1 text-base font-bold text-white hover:text-[var(--faro-yellow)] transition-colors whitespace-nowrap"
      >
        {item.label} <ChevronDown size={14} className="group-hover:rotate-180 transition-transform" />
      </a>
      <div className="absolute left-0 top-full pt-3 hidden group-hover:block group-focus-within:block z-50">
        <div className="bg-white rounded-2xl shadow-2xl border border-[rgba(30,42,143,0.12)] p-2 min-w-[260px]" data-testid={`nav-dropdown-${item.label.toLowerCase().replace(/\s/g, "-")}`}>
          {item.catalog && (
            <>
              <a href={item.href} className="block px-4 py-2.5 rounded-xl text-sm font-black text-[var(--faro-blue-deep)] hover:bg-[var(--faro-bg)]" data-testid="nav-dd-catalogo">
                {item.catalog}
              </a>
              <div className="my-1 border-t border-[rgba(30,42,143,0.1)]" />
            </>
          )}
          {item.dropdown.map((d) => (
            <Link
              key={d.to}
              to={d.to}
              data-testid={`nav-dd${d.to.replace(/\//g, "-")}`}
              className="block px-4 py-2.5 rounded-xl text-sm font-semibold text-[var(--faro-text)] hover:bg-[var(--faro-bg)] hover:text-[var(--faro-blue)]"
            >
              {d.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

const MobileMenuItem = ({ item, openSub, setOpenSub, closeMenu }) => {
  if (!item.dropdown) {
    return (
      <a
        href={item.href}
        data-testid={`nav-mobile-${item.label.toLowerCase().replace(/\s/g, "-")}`}
        className="py-3 font-semibold text-[var(--faro-text)] border-b border-[rgba(30,42,143,0.08)]"
        onClick={closeMenu}
      >
        {item.label}
      </a>
    );
  }
  const expanded = openSub === item.label;
  return (
    <>
      <button
        type="button"
        data-testid={`nav-mobile-${item.label.toLowerCase().replace(/\s/g, "-")}`}
        aria-expanded={expanded}
        onClick={() => setOpenSub(expanded ? null : item.label)}
        className="py-3 font-semibold text-[var(--faro-text)] flex items-center justify-between w-full text-left border-b border-[rgba(30,42,143,0.08)]"
      >
        {item.label}
        <ChevronDown
          size={18}
          className={`text-[var(--faro-red)] transition-transform ${expanded ? "rotate-180" : ""}`}
        />
      </button>
      {expanded && (
        <div className="pl-4 py-1 flex flex-col border-l-2 border-[rgba(30,42,143,0.12)]" data-testid={`nav-mobile-sub-${item.label.toLowerCase().replace(/\s/g, "-")}`}>
          <a
            href={item.href}
            className="py-2 text-sm font-bold text-[var(--faro-blue)]"
            onClick={closeMenu}
            data-testid={`nav-mobile-catalog-${item.label.toLowerCase().replace(/\s/g, "-")}`}
          >
            {item.catalog || `Ver ${item.label.toLowerCase()}`}
          </a>
          {item.dropdown.map((d) => (
            <Link
              key={d.to}
              to={d.to}
              data-testid={`nav-mobile-dd${d.to.replace(/\//g, "-")}`}
              className="py-2 text-sm font-medium text-[var(--faro-text-soft)]"
              onClick={closeMenu}
            >
              {d.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

const MobileMenu = ({ openSub, setOpenSub, closeMenu }) => (
  <div className="xl:hidden bg-white border-t border-[rgba(30,42,143,0.1)] max-h-[calc(100dvh-72px)] overflow-y-auto" data-testid="mobile-menu">
    <div className="px-5 py-4 flex flex-col gap-1">
      {NAV.map((n) => (
        <MobileMenuItem key={n.href} item={n} openSub={openSub} setOpenSub={setOpenSub} closeMenu={closeMenu} />
      ))}
      <a
        href="/#contacto"
        data-testid="mobile-cta"
        className="btn-pill btn-primary justify-center mt-3"
        onClick={closeMenu}
      >
        Matricúlate
      </a>
    </div>
  </div>
);

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [openSub, setOpenSub] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 bg-white ${
        scrolled ? "shadow-lg shadow-[rgba(19,26,95,0.12)]" : ""
      }`}
    >
      <div className="pt-8 sm:pt-10">
        <div style={{ backgroundColor: HEADER_LOGO_BLUE }}>
          <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-16 sm:h-20 gap-4">
            <Link to="/" data-testid="logo-link" className="flex items-center shrink-0">
              <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden -my-5 sm:-my-7 shadow-xl ring-4 ring-white bg-white">
                <img
                  src={HEADER_LOGO}
                  alt="Autoescuelas Faro - inicio"
                  width="48"
                  height="48"
                  className="w-full h-full object-cover scale-105"
                />
              </div>
            </Link>

            <nav className="hidden xl:flex items-center gap-7 flex-1 justify-start pl-8">
              {NAV.map((n) => (
                <DesktopNavItem key={n.href} item={n} />
              ))}
            </nav>

            <div className="hidden xl:flex items-center shrink-0 pl-4 border-l border-white/20">
              <a
                href="/#contacto"
                data-testid="header-cta"
                className="btn-pill btn-primary text-sm border-2 border-white cta-pulse"
              >
                Matricúlate
              </a>
            </div>

            <button
              data-testid="mobile-menu-toggle"
              className="xl:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/40 text-white"
              onClick={() => setOpen((v) => !v)}
              aria-label="Abrir menú"
            >
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>
      </div>

      {open && <MobileMenu openSub={openSub} setOpenSub={setOpenSub} closeMenu={() => setOpen(false)} />}
    </header>
  );
}
